// Masks
export const PATHING_TYPES = {
	WALKABLE: 1,
	BUILDABLE: 2,
};

export const DIRECTION = {
	DOWN: 0,
	RIGHT: 1,
	UP: 2,
	LEFT: 3,
};
